import React, { Fragment, useEffect } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import {
    setIsConfirm,
    removeConfirmMessage,
    removeConfirmField
} from "../../redux-store/action/modals/confirm";
import { updatePropertyFields } from "../../redux-store/action/properties/properties";
import { updateAutomobileData } from "../../redux-store/action/automobiles/automobiles";

const ConfirmModal = ({
    message,
    setIsConfirm,
    confirmField,
    isConfirm,
    propertyOldValue,
    automobileOldValue,
    removeConfirmMessage,
    removeConfirmField,
    updatePropertyFields,
    updateAutomobileData,
    history: { location: { pathname } }
}) => {
    useEffect(() => {
        confirmUpdateField();
    }, [isConfirm]);

    const confirmUpdateField = async() => {
    //  setIsConfirm must be setting to `null` to trigger useEffect on falsy. Setting it to false
    //  might be the same as null but useEffect see false === false and false !== null
        if (
            ["group_code",
                "task_order",
                "code",
                "code_temp"].includes(
                confirmField
            )
        ) {
            if (isConfirm && confirmField) {
                await removeConfirmMessage();
                await removeConfirmField();
                setIsConfirm(null);
            }
            else if (!isConfirm && confirmField) {
                if (pathname.startsWith("/app/automobiles")) {
                    const event = {
                        target: {
                            name: confirmField,
                            value: automobileOldValue,
                            dataset: { displayName: "" }
                        },
                        status: "No",
                        persist: () => {}
                    };
                    await updateAutomobileData(event);
                }
                else if (pathname.startsWith("/app/properties")) {
                    const event = {
                        target: {
                            name: confirmField,
                            value: propertyOldValue,
                            dataset: { displayName: "" }
                        },
                        status: "No",
                        persist: () => {}
                    };
                    await updatePropertyFields(event);
                }
                await removeConfirmMessage();
                await removeConfirmField();
                setIsConfirm(null);
            }
        }
    };

    return (
        <Fragment>
            <input
                type="hidden"
                data-toggle="modal"
                id="confirmModalButton"
                data-target="#confirmModal"
            />

            <div
                className="modal fade"
                id="confirmModal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="confirmModalLabel"
                aria-hidden="true"
                data-backdrop="static"
                style={{ top: "50px" }}
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="confirmModalLabel">
                                Message
                            </h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>{message}</p>
                        </div>
                        <div className="modal-footer">
                            <button
                                onClick={() => setIsConfirm(false)}
                                type="button"
                                className="btn btn-danger"
                                data-dismiss="modal"
                            >
                                No
                            </button>
                            <button
                                onClick={() => setIsConfirm(true)}
                                type="button"
                                className="btn btn-success"
                                data-dismiss="modal"
                            >
                                Yes
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

ConfirmModal.propTypes = {
    updateAutomobileData: PropTypes.func,
    updatePropertyFields: PropTypes.func
};

const mapStateToProps = state => ({
    message: state.confirmModal.message,
    confirmField: state.confirmModal.confirmField,
    isConfirm: state.confirmModal.isConfirm,
    propertyOldValue: state.properties.oldValue,
    automobileOldValue: state.automobiles.oldValue
});

export default connect(mapStateToProps, {
    setIsConfirm,
    removeConfirmMessage,
    removeConfirmField,
    updatePropertyFields,
    updateAutomobileData
})(ConfirmModal);